import firebase from 'firebase';

var authUIConfig = {
    signInSuccessUrl: '/',
    signInFlow: 'popup',
    signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        firebase.auth.TwitterAuthProvider.PROVIDER_ID,
        firebase.auth.GithubAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        firebase.auth.PhoneAuthProvider.PROVIDER_ID
    ],
    // Terms of service url.
    tosUrl: ''
};

const firebaseConfig = {
    apiKey: "AIzaSyC_L2r7ODIiXYHWgKDxIB1hnIJAh_KmYP0",
    authDomain: "idna-pwa-d38d9.firebaseapp.com",
    databaseURL: "https://idna-pwa-d38d9.firebaseio.com",
    projectId: "idna-pwa-d38d9",
    storageBucket: "idna-pwa-d38d9.appspot.com",
    messagingSenderId: "947380336938"
  };

export {authUIConfig, firebaseConfig};


// WEBPACK FOOTER //
// ./src/utils/FirebaseConfig.js